function Error({ message }) {
  return (
    <div className="overlay overlay-error">
      <div className="error-container">
        <p>{message}</p>
      </div>
    </div>
  );
}

export default Error;
